<template>
    <v-server-table :url="url ? url : route('milestones.table')" :columns="columns" :options="options" class="trigger" ref="table">
        <template slot="name" slot-scope="props">
            <router-link :to="{ name: 'admin.trajectory_projects.trajectories.milestones.view', params: { projectId: props.row.trajectory.trajectory_project_id, trajectoryId: props.row.trajectory_id, id: props.row.id }}">{{ props.row.name }}</router-link>
        </template>
    </v-server-table>
</template>

<script>
    import Actions from './actions'
    import { TableMixin } from '~/mixins'

    export default {
        name: 'index',
        mixins: [ TableMixin ],
        props: {
            url: {
                type: String,
                required: false,
                default: null,
            }
        },

        data () {
            return {
                columns: [
                    'name',
                    'lead_time_in_days',
                    'maximum_hours',
                    'actions',
                ],
                filterable: [
                    'name',
                    'lead_time_in_days',
                    'maximum_hours',
                ],
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        name: this.uLang('app.name'),
                        lead_time_in_days: uLang('app.lead_time_in_days'),
                        maximum_hours: uLang('app.maximum_hours'),
                        actions: this.uLang('app.actions'),
                    },
                },
            }
        },
    }
</script>

<style lang="css" scoped>
</style>